/* 🤖 this file was generated by svg-to-ts */
export const iconChevronDown = {
    name: 'chevron_down',
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" data-source="heroicicons" data-name="solid/chevron-down" width="1em" height="1em"><path fill-rule="evenodd" d="M12.53 16.28a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 0 1 1.06-1.06L12 14.69l6.97-6.97a.75.75 0 1 1 1.06 1.06l-7.5 7.5Z" clip-rule="evenodd"/></svg>`,
};
